module.exports = __webpack_public_path__ + "static/media/soil_tile.96d24b0e.png";